<template>
    <v-dialog v-model="openMode" max-width="780px" content-class="mm-dialog" overlay-color="#0d2c6d"
        overlay-opacity="0.55" transition="dialog-bottom-transition">
        <v-card class="mm-dlg-card">
            <div class="mm-dlg-head">
                <div class="mm-dlg-head__main">
                    <div class="mm-dlg-head__icon" aria-hidden="true">
                        <v-icon color="white">mdi-pencil-outline</v-icon>
                    </div>
                    <div>
                        <span class="mm-dlg-eyebrow">עריכת מנוי</span>
                        <h2 class="mm-dlg-title">{{ formTitle }}</h2>
                    </div>
                </div>
                <div class="mm-dlg-head__pill" v-if="itemEdited.manui_number">
                    <v-icon small color="white">mdi-cellphone</v-icon>
                    {{ itemEdited.manui_number }}
                </div>
                <button type="button" class="mm-dlg-close" @click="openMode = false" aria-label="סגור">
                    <v-icon small color="white">mdi-close</v-icon>
                </button>
            </div>

            <v-card-text class="mm-dlg-body">
                <v-form @submit.prevent="submitHandler" ref="form">
                    <div class="mm-dlg-section" v-if="!nothingToEdit()">
                        <h3 class="mm-dlg-section__title">
                            <span class="mm-dlg-section__bar"></span>
                            פרטים לעריכה
                        </h3>
                        <v-row>
                            <v-col cols="12" sm="6" v-if="itemEdited.type === 'מנוי חדש' && !isManuiNumberExist">
                                <v-text-field v-model="itemEdited.manui_number" label="מספר מנוי" outlined dense
                                    class="mm-ltr-number" prepend-inner-icon="mdi-cellphone"
                                    :rules="[v => !!v || 'שדה חובה']" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" v-if="isManuiNumberExist">
                                <v-select v-if="currentStatus === 'active'" :items="activeStatusOptions"
                                    :item-text="'hebrewName'" :item-value="'name'" hide-details
                                    v-model="itemEdited.status" outlined dense label="סטטוס"
                                    prepend-inner-icon="mdi-list-status">
                                </v-select>
                                <v-select v-else-if="currentStatus === 'proccess' && role === 'admin'"
                                    :items="processstatusOptions" :item-text="'hebrewName'" :item-value="'name'"
                                    hide-details v-model="itemEdited.status" outlined dense label="סטטוס"
                                    prepend-inner-icon="mdi-list-status">
                                </v-select>
                            </v-col>
                            <v-col cols="12" v-if="itemEdited.status === 'not_active'">
                                <v-checkbox v-model="disableSchedule" label="ביטול מיידי" color="#0d2c6d"></v-checkbox>
                            </v-col>
                        </v-row>
                    </div>

                    <div class="mm-dlg-section" v-if="nothingToEdit()">
                        <div class="mm-dlg-empty">
                            <v-icon large color="#94a3b8">mdi-information-outline</v-icon>
                            <div class="mt-2">אין נתונים לעריכה</div>
                        </div>
                    </div>
                </v-form>
            </v-card-text>

            <div class="mm-dlg-foot" v-if="!nothingToEdit()">
                <v-progress-linear v-if="progressShow" indeterminate color="#0d2c6d" height="3"
                    class="mm-dlg-progress" />
                <div class="mm-dlg-foot__actions">
                    <button type="button" class="mm-dlg-btn mm-dlg-btn--ghost" @click="openMode = false">
                        <v-icon small>mdi-close</v-icon>
                        ביטול
                    </button>
                    <button type="button" class="mm-dlg-btn mm-dlg-btn--primary"
                        @click="formTitle === 'ערוך פרטי מנוי' ? saveEditedItem() : saveNewItem()"
                        :disabled="progressShow">
                        <v-icon small color="white">mdi-content-save-outline</v-icon>
                        שמור
                    </button>
                </div>
            </div>
        </v-card>

        <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
    </v-dialog>
</template>

<script>
import SnackBar from '@/components/widgets/snackBar.vue'
import ApiServices from '@/services/api.service'
import Auth from '@/services/auth.service';

export default {
    props: {
        itemToEdit: Object,
        formTitle: String,
        customerId: String,
        value: { type: Boolean, default: false },
    },
    components: {
        SnackBar,
    },
    data: () => ({
        progressShow: false,
        snackbar: false,
        snackbarColorBt: "green",
        snacbarText: "",
        itemEdited: {
            _id: "",
            manui_number: "",
            status: "",
        },
        isManuiNumberExist: false,
        currentStatus: "",
        disableSchedule: false,
        activeStatusOptions: [{ hebrewName: "פעיל", name: "active" }, { hebrewName: "לא פעיל", name: "not_active" }],
        processstatusOptions: [{ hebrewName: "פעיל", name: "active" }, { hebrewName: "בתהליך", name: "proccess" }],
        role: "",
    }),
    methods: {
        async saveEditedItem() {
            if (this.$refs.form.validate()) {

                const myJSON = JSON.stringify({ customerId: this.customerId, manui: this.itemEdited, oldStatus: this.currentStatus, disableSchedule: this.disableSchedule });
                this.progressShow = true;
                let token = localStorage.getItem("token");

                try {
                    let api = process.env.VUE_APP_BASE_URL + "/manuim/edit_manui";
                    const res = await fetch(api, ApiServices.requestOptions("PUT", myJSON, token));
                    this.progressShow = false;
                    const jsonObject = await res.json();
                    if (res.status >= 400) {
                        this.showSnackBar("Error: " + jsonObject.message, "red");
                    } else if (res.status === 200) {
                        this.itemEdited.status = jsonObject.status;
                        this.itemEdited.deletedAt = jsonObject.deletedAt;
                        this.itemEdited.deletedBy = jsonObject.deletedBy;
                        this.$emit("itemEdited", this.itemEdited, "המנוי עודכן בהצלחה", "green");
                        this.openMode = false;
                    }
                } catch (error) {
                    this.progressShow = false;
                    this.showSnackBar("Error saved edited customer: " + error, "red");

                }

            }
        },
        showSnackBar(message, color) {
            this.snacbarText = message;
            this.snackbarColorBt = color;
            this.snackbar = true
        },
        nothingToEdit() {
            return !(this.itemEdited.type === 'מנוי חדש' && !this.isManuiNumberExist) && !this.isManuiNumberExist
        }
    },
    computed: {
        openMode: {
            get() {
                return this.value
            },
            set(v) {
                return this.$emit('input', v)
            }
        },
    },
    mounted() {
        if (this.formTitle === "ערוך פרטי מנוי") {
            this.itemEdited = JSON.parse(JSON.stringify(this.itemToEdit));
            this.currentStatus = JSON.parse(JSON.stringify(this.itemEdited.status));;
            if (this.itemEdited.manui_number) {
                this.isManuiNumberExist = true;
            }
        }
        this.role = Auth.getUserRole();
    },
}
</script>
<style scoped>
.mm-dialog {
    border-radius: 20px !important;
    overflow: hidden;
}

.mm-dlg-card {
    --mm-navy: #0d2c6d;
    --mm-indigo: #3F51B5;
    --mm-purple: #8066f0;
    --mm-gold: #fdb721;
    --mm-border: #eef2f7;
    --mm-text: #0f172a;
    --mm-text-soft: #475569;
    --mm-text-mute: #94a3b8;
    font-family: 'Assistant', 'Heebo', system-ui, sans-serif;
    direction: rtl;
    border-radius: 20px !important;
    overflow: hidden;
    background: #ffffff !important;
}

.mm-dlg-head {
    position: relative;
    background:
        radial-gradient(800px 200px at 90% -40%, rgba(253, 183, 33, 0.08), transparent 60%),
        linear-gradient(135deg, #0d2c6d 0%, #142f78 55%, #1a3a8a 100%);
    color: #fff;
    padding: 18px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.mm-dlg-head__main {
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
}

.mm-dlg-head__icon {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    border-radius: 11px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.22);
    display: grid;
    place-items: center;
    color: #fff;
}

.mm-dlg-eyebrow {
    display: block;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.65);
    margin-bottom: 1px;
}

.mm-dlg-title {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 800;
    letter-spacing: -0.01em;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mm-dlg-head__pill {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    min-height: 34px;
    padding: 7px 12px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.12);
    border: 1px solid rgba(255, 255, 255, 0.18);
    color: rgba(255, 255, 255, 0.88);
    font-size: 0.82rem;
    font-weight: 700;
    white-space: nowrap;
}

.mm-dlg-close {
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.10);
    border: 1px solid rgba(255, 255, 255, 0.18);
    color: #fff;
    cursor: pointer;
    display: grid;
    place-items: center;
    transition: background 0.2s, transform 0.2s;
}

.mm-dlg-close:hover {
    background: rgba(255, 255, 255, 0.18);
    transform: rotate(90deg);
}

.mm-dlg-body {
    padding: 24px 28px 8px !important;
    background: #fbfcfe;
    max-height: 65vh;
    overflow-y: auto;
}

.mm-dlg-section {
    margin-bottom: 18px;
    padding: 16px 18px 6px;
    background: #ffffff;
    border: 1px solid var(--mm-border);
    border-radius: 14px;
    box-shadow: 0 12px 28px -24px rgba(15, 23, 42, 0.35);
}

.mm-dlg-section__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.92rem;
    font-weight: 700;
    color: var(--mm-navy);
    margin: 0 0 14px;
}

.mm-dlg-section__bar {
    width: 3px;
    height: 16px;
    background: linear-gradient(180deg, var(--mm-navy), var(--mm-purple));
    border-radius: 2px;
}

.mm-dlg-section__hint {
    color: var(--mm-text-soft);
    font-size: 0.86rem;
    line-height: 1.7;
    margin: -4px 0 14px;
}

.mm-dlg-info-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    margin-bottom: 14px;
    border-radius: 12px;
    background: #f8fafc;
    border: 1px solid #e3e8ef;
    color: var(--mm-text-soft);
    font-weight: 700;
}

.mm-dlg-empty {
    text-align: center;
    color: var(--mm-text-mute);
    padding: 28px 10px;
    font-weight: 700;
}

.mm-ltr-number input,
.mm-ltr-number .v-input__slot input {
    direction: ltr;
    text-align: left;
    letter-spacing: 0.02em;
}

::v-deep .v-text-field--outlined fieldset {
    border-color: #e3e8ef !important;
    transition: border-color 0.2s, box-shadow 0.2s;
}

::v-deep .v-text-field--outlined:hover fieldset {
    border-color: #c7d2e0 !important;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
    border-color: var(--mm-navy) !important;
    border-width: 2px !important;
    box-shadow: 0 0 0 4px rgba(13, 44, 109, 0.06);
}

::v-deep .v-input .v-label,
::v-deep .v-input input,
::v-deep .v-input textarea,
::v-deep .v-select__selection {
    font-family: inherit;
}

::v-deep .v-input__prepend-inner {
    margin-top: 9px !important;
}

::v-deep .v-input__prepend-inner .v-icon {
    color: var(--mm-text-mute) !important;
}

::v-deep .v-input--is-focused .v-input__prepend-inner .v-icon {
    color: var(--mm-navy) !important;
}

.mm-dlg-foot {
    background: #ffffff;
    border-top: 1px solid var(--mm-border);
}

.mm-dlg-progress {
    display: block;
}

.mm-dlg-foot__actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 14px 22px;
}

.mm-dlg-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 22px;
    border-radius: 10px;
    border: none;
    font-family: inherit;
    font-weight: 700;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.mm-dlg-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.mm-dlg-btn--ghost {
    background: transparent;
    color: var(--mm-text-soft);
    border: 1px solid #e3e8ef;
}

.mm-dlg-btn--ghost:hover:not(:disabled) {
    background: #f8fafc;
    color: var(--mm-text);
}

.mm-dlg-btn--primary {
    background: linear-gradient(135deg, var(--mm-navy) 0%, #142f78 100%);
    color: #fff;
    box-shadow: 0 6px 14px -4px rgba(13, 44, 109, 0.45);
}

.mm-dlg-btn--primary:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.08);
}

.mm-dlg-btn--danger {
    background: linear-gradient(135deg, #b42318 0%, #d92d20 100%);
    color: #fff;
    box-shadow: 0 6px 14px -4px rgba(180, 35, 24, 0.45);
}

.mm-dlg-btn--danger:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.05);
}

.mm-delete-box {
    text-align: center;
    padding: 10px 0 18px;
}

.mm-delete-icon {
    width: 56px;
    height: 56px;
    margin: 0 auto 14px;
    border-radius: 18px;
    background: #fff1f0;
    color: #d92d20;
    display: grid;
    place-items: center;
}

.mm-delete-title {
    margin: 0 0 8px;
    color: var(--mm-text);
    font-size: 1.05rem;
    font-weight: 800;
}

.mm-delete-text {
    margin: 0;
    color: var(--mm-text-soft);
    font-size: 0.9rem;
    line-height: 1.7;
}

@media (max-width: 600px) {
    .mm-dlg-head {
        padding: 14px 18px;
    }

    .mm-dlg-title {
        font-size: 1rem;
    }

    .mm-dlg-head__pill {
        display: none;
    }

    .mm-dlg-body {
        padding: 18px 18px 4px !important;
    }

    .mm-dlg-section {
        padding: 14px 14px 4px;
    }

    .mm-dlg-foot__actions {
        padding: 12px 16px;
    }

    .mm-dlg-btn {
        padding: 9px 16px;
        font-size: 0.85rem;
    }
}
</style>
